// draggable-schedule.directive.ts
import { Directive, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import ims from '../../imports';
@Directive({
  selector: '[appDraggableSchedule]',
  standalone: false
})
export class DraggableScheduleDirective {
  @Input() armingSchedules: any;
  @Input() schedule: any;
  @Input() container!: HTMLElement; // amContainer or pmContainer
  @Input() isPm: boolean = false;
  @Input() week: number;
  @Input() getTimeFromPosition!: (x: number, containerWidth: number, isPm: boolean) => string;
  @Input() isEditMode: boolean = false;
  @Output() update: EventEmitter<any> = new EventEmitter();

  private dragging = false;
  private mouseMoveHandler = this.onDrag.bind(this);
  private mouseUpHandler = this.endDrag.bind(this);

  private originSchedule = null;
  private newTime = null;
  private dynamicIsPm = false;

  constructor(private el: ElementRef) {
    this.el.nativeElement.addEventListener('mousedown', (e: MouseEvent) => this.startDrag(e));
  }

  ngOnInit(){
    if(this.schedule.startTime) this.originSchedule = ims._.cloneDeep(this.schedule);
  }

  startDrag(event: MouseEvent) {
    event.preventDefault();
    if (!this.isEditMode) return;
    this.dragging = true;
    this.el.nativeElement.classList.add('dragging');

    document.addEventListener('mousemove', this.mouseMoveHandler);
    document.addEventListener('mouseup', this.mouseUpHandler);
  }

  onDrag(event: MouseEvent) {
    if (!this.dragging || !this.container) return;

    const rect = this.container.getBoundingClientRect();
    const relativeX = event.clientX - rect.left;
    const halfWidth = rect.width / 2;

    // 현재 마우스가 AM 영역인지, PM 영역인지 판별
    this.dynamicIsPm = relativeX >= halfWidth;

    // 로컬 컨테이너 폭 (반쪽)
    const localWidth = halfWidth;
    const position = relativeX % halfWidth

    // AM/PM 기준 좌표 계산
    this.newTime = this.getTimeFromPosition(position, localWidth, this.dynamicIsPm);
    this.schedule.startTime = this.newTime;
  }

  checkDuplicated(selHour, selMinutes){
    let ampm = 'am';
    parseInt(selHour) < 12 ? ampm = 'am' : ampm = 'pm';
    const timestamp = (parseInt(selHour) * 60 * 60) + (parseInt(selMinutes) * 60);
    this.isDuplicatedSchedule(ampm, timestamp)
  }

  isDuplicatedSchedule(ampm, timestamp){
    const targetWeek = this.armingSchedules[this.week+1][ampm]
    const target = targetWeek.find(v => v.timestamp === timestamp)
    if(target) {
      alert('The same time has already been registered.')
      this.newTime = this.originSchedule.startTime;
      this.endDrag();
      return true;
    }
    return false;
  }

  endDrag() {
    if (!this.dragging) return;

    this.dragging = false;
    this.el.nativeElement.classList.remove('dragging');

    document.removeEventListener('mousemove', this.mouseMoveHandler);
    document.removeEventListener('mouseup', this.mouseUpHandler);

    if (!this.newTime) return;
    const [selHour, selMinutes] = this.newTime.split(':')
    this.checkDuplicated(selHour, selMinutes)
    this.updateTime()
  }

  updateTime(){
    if (!this.newTime) return;
    const [selHour, selMinutes] = this.newTime.split(':')
    const timestamp = (parseInt(selHour) * 60 * 60) + (parseInt(selMinutes) * 60);
    this.schedule.startTime = this.newTime
    this.schedule.start_time = `${selHour}:${selMinutes}:00`
    this.schedule.timestamp = timestamp;

    const data = { schedule: this.schedule, week: this.week, dynamicIsPm: this.dynamicIsPm, isPm: this.isPm }
    this.update.emit(data)
  }

  ngOnDestroy() {
    this.endDrag();
  }
}
